module.exports = __webpack_public_path__ + "static/media/MICH3.48992311.png";